import { useKV } from "@/hooks/use-kv-adapter";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Payslip } from "@/types/payroll";
import { FilePdf, DownloadSimple, Eye } from "@phosphor-icons/react";

export function Payslips() {
  const [payslips] = useKV<Payslip[]>("payroll-payslips", [
    {
      id: "pay-jan-26",
      employeeId: "CURRENT_USER",
      month: "2026-01",
      basicSalary: 5000,
      allowances: 1000,
      deductions: 500,
      tax: 800,
      netSalary: 4700,
      paymentDate: "2026-01-31",
      status: "Paid"
    },
    {
      id: "pay-dec-25",
      employeeId: "CURRENT_USER",
      month: "2025-12",
      basicSalary: 5000,
      allowances: 1000,
      deductions: 500,
      tax: 800,
      netSalary: 4700,
      paymentDate: "2025-12-31",
      status: "Paid"
    }
  ]);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="bg-gradient-to-br from-blue-500 to-blue-600 text-white border-none">
          <CardHeader>
            <CardTitle className="text-white/80 text-sm font-medium">Last Net Salary</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-4xl font-bold">$4,700.00</div>
            <p className="text-white/60 text-sm mt-1">Paid on Jan 31, 2026</p>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Payslip History</CardTitle>
          <CardDescription>View and download your monthly payslips</CardDescription>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Month</TableHead>
                <TableHead>Basic</TableHead>
                <TableHead>Allowances</TableHead>
                <TableHead>Deductions</TableHead>
                <TableHead>Net Pay</TableHead>
                <TableHead>Status</TableHead>
                <TableHead className="text-right">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {payslips.map((payslip) => (
                <TableRow key={payslip.id}>
                  <TableCell className="font-medium">
                    {new Date(payslip.month + "-01").toLocaleString('default', { month: 'long', year: 'numeric' })}
                  </TableCell>
                  <TableCell>${payslip.basicSalary.toLocaleString()}</TableCell>
                  <TableCell>${payslip.allowances.toLocaleString()}</TableCell>
                  <TableCell className="text-red-500">-${(payslip.deductions + payslip.tax).toLocaleString()}</TableCell>
                  <TableCell className="font-bold text-green-600">${payslip.netSalary.toLocaleString()}</TableCell>
                  <TableCell>
                    <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                      {payslip.status}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-2">
                      <Button variant="ghost" size="sm" title="View">
                        <Eye className="h-4 w-4" />
                      </Button>
                      <Button variant="ghost" size="sm" title="Download PDF">
                        <FilePdf className="h-4 w-4 text-red-500" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
